import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Block, Flex } from '../../../design-system';
import { matchSorter } from 'match-sorter';
import { Table } from '../../../components/Table';
import { AGENCY_COLUMNS } from '../constants';
import { useData } from '../../../helpers/data-loader';
import { checkPermissions, errorMsg } from '../../../helpers/utils';
import { Session } from '../../../contexts/sessionContext';
import { PERMISSIONS } from '../../../globalConstants';
import SearchFilter from '../../../components/SearchFilter';

const AgencyList = () => {
  const {
    state: {
      user: { permissions },
    },
  } = useContext(Session);
  const canEdit = useMemo(
    () => checkPermissions(permissions, [PERMISSIONS.SUPER_ADMIN]),
    [permissions],
  );
  const [agencies, fetchAgencies, loadingAgencies] = useData('/admin', {
    errorMsg: errorMsg('Agencies'),
  });
  const [filter, setFilter] = useState('');

  useEffect(() => {
    fetchAgencies();
  }, [fetchAgencies]);

  const filteredAgencies = useMemo(
    () =>
      matchSorter(agencies, filter, {
        keys: [
          {
            threshold: matchSorter.rankings.CONTAINS,
            key: 'name',
          },
          {
            threshold: matchSorter.rankings.CONTAINS,
            key: 'membership',
          },
        ],
      }),
    [agencies, filter],
  );

  return (
    <Block mt={30}>
      <Flex
        justifyContent="flex-start"
        alignItems="center"
        p="0 36px 18px 26px"
      >
        <Block width={250}>
          <SearchFilter onFilter={setFilter} />
        </Block>
      </Flex>
      <Table
        name="Agencies"
        columns={AGENCY_COLUMNS}
        data={(filteredAgencies as any[]).map((item: any) => ({
          ...item,
          canEdit,
        }))}
        loading={loadingAgencies}
      />
    </Block>
  );
};

export default AgencyList;
